/* Copyright (c) 2017 Backpack Health LLC */

/* global window */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import IconPrivacy from '../../../components/icons/IconPrivacy';
import Card, { CardSection, EmptyCard } from '../../../components/card/Card';
import { Button } from '../../../components/buttons/Buttons';
import PreformattedText from '../../../components/PreformattedText';
import LegalDocumentLinks from '../../../components/LegalDocumentLinks';
import Spacer from '../../../components/Spacer';
import { FootnoteTextList } from '../../../components/List';
import PrivacyHeader from '../../../components/PrivacyHeader';
import { TextLink, MailToLink } from '../../../components/TextLink';
import CustomerService from '../../../../utilities/CustomerService';
import { TrackEvent } from '../../../../utilities/UserMetrics';

interface Props {
  isNewUser: boolean;
  onAccept(): void;
  style?: object;
}

class PrivacyIntroContent extends React.Component<Props, {}> {

  onAccept = () => {
    const { isNewUser, onAccept } = this.props;

    if (isNewUser) {
      TrackEvent.signup.acceptedPrivacy();
    }

    onAccept();
  }

  render() {
    const { onAccept, style } = this.props;

    return (
      <div className="cmp-privacyintrocontent" style={style}>
        <EmptyCard className="font-footnote font-color-white">
          <IconPrivacy.XLarge color="white" />

          <h2 className="font-title-1 font-color-white padding-32">
            <FormattedMessage id="privacyIntro.title.text" />
          </h2>
        </EmptyCard>

        <Card style={{ margin: '0 8px' }}>
          <CardSection hasBorder={false}>
            <PrivacyHeader />

            <Spacer size="9" />

            <PreformattedText text="privacyIntro.message.text" textClassName="font-subhead font-color-gsMedDark" />

            <p className="font-subhead" style={{ marginTop: 24 }}>
              <FormattedMessage id="privacyIntro.email.field.label" /> <FormattedMessage id="privacyIntro.email.button.label">
                {
                  (email) => (
                    <MailToLink email={email} className="font-color-rb-dark-accent">
                      {email}
                    </MailToLink>
                  )
                }
              </FormattedMessage>
            </p>
          </CardSection>
        </Card>

        <Spacer size="16" />

        <div className="util-inset-card-margin">
          <Button className="bkgd-color-rb-dark-accent font-color-white" type={null} size="wide" onClick={this.onAccept}>
            <FormattedMessage id="privacyIntro.submit.button.label" />
          </Button>
        </div>

        <EmptyCard className="font-footnote font-color-white">
          <FootnoteTextList>
            <li>
              <FormattedMessage id="privacyIntro.privacyTermsAcceptance.message.text" />
            </li>
            <li>
              <LegalDocumentLinks.PrivacyPolicy className="font-color-white" style={{ textDecoration: 'underline' }}>
                <FormattedMessage id="legal.privacyPolicy.URL.name" />
              </LegalDocumentLinks.PrivacyPolicy>
            </li>
            <li>
              <LegalDocumentLinks.CookiePolicy className="font-color-white" style={{ textDecoration: 'underline' }}>
                <FormattedMessage id="legal.cookiePolicy.URL.name" />
              </LegalDocumentLinks.CookiePolicy>
            </li>
            <li>
              <LegalDocumentLinks.TermsOfService className="font-color-white" style={{ textDecoration: 'underline' }}>
                <FormattedMessage id="legal.termsOfService.URL.name" />
              </LegalDocumentLinks.TermsOfService>
            </li>
          </FootnoteTextList>
        </EmptyCard>
      </div>
    );
  }
}

export default PrivacyIntroContent;
